<main class="commercial-page">
  <pds-module-header [title]="title" ctaLabel="Voltar" [ctaOnClick]="navigateBack.bind(this)">
    <div class="commercial-page__content">
      <form [formGroup]="form" class="commercial-page__form">
        <pds-form-row grid="1-1">
          <pds-form-field label="Canais de venda">
            <pds-multi-select-autocomplete placeholder="Pesquisar canais" formControlName="salesChannels" [source]="salesChannelsSuggestions" (autocomplete)="onSalesChannelsAutocomplete($event)"> </pds-multi-select-autocomplete>
          </pds-form-field>

          <pds-form-field label="Vendedores">
            <pds-multi-select-autocomplete placeholder="Pesquisar vendedores" formControlName="sellers" [source]="sellerSuggestions" (autocomplete)="onSellerAutocomplete($event)"> </pds-multi-select-autocomplete>
          </pds-form-field>
        </pds-form-row>

        <pds-form-row grid="1">
          <pds-form-field label="Filiais">
            <div *ngFor="let seller of form.get('sellers')?.value || []" class="seller-block">
              <strong>{{ seller.label }}</strong>

              <div *ngIf="!branchesBySeller[seller.id]">Carregando filiais...</div>

              <div *ngIf="branchesBySeller[seller.id]">
                <div class="branch-list">
                  <label *ngFor="let branch of branchesBySeller[seller.id]" class="branch-item">
                    <pds-checkbox [label]="branch.label" [checked]="selectedBranches[seller.id] && selectedBranches[seller.id].has(branch.id)" (click)="onBranchCheckboxChange(seller.id, branch.id)"> </pds-checkbox>
                  </label>
                </div>
              </div>
            </div>
          </pds-form-field>
        </pds-form-row>
      </form>

      <pds-form-actions class="commercial-page__actions">
        <button pdsButton="terciary" type="button" *ngIf="mode === 'edit' && !isEditing" [disabled]="loading" (click)="onClickDelete()">Excluir</button>
        <button pdsButton="terciary" type="button" *ngIf="mode === 'edit' && isEditing" [disabled]="loading" (click)="navigateBack()">Cancelar</button>
        <button pdsButton="primary" type="button" *ngIf="mode === 'edit'" [disabled]="loading" (click)="onClickDeactivate()">
          {{ form.value.enabled ? 'Desativar' : 'Ativar' }}
        </button>
        <button pdsButton type="button" *ngIf="mode === 'edit' && !isEditing" [disabled]="loading" (click)="onClickEdit()">Editar</button>
        <button pdsButton type="button" *ngIf="mode === 'create' || isEditing" [disabled]="form.invalid || loading" (click)="onClickSave()">
          {{ mode === 'create' ? 'Salvar' : 'Atualizar' }}
        </button>
      </pds-form-actions>
    </div>
  </pds-module-header>
</main>
